export enum UserTitle {
  MR = 'Mr.',
  MS = 'Ms.',
}

export const userTitles = Object.values(UserTitle).map(item => {
  return { label: ['checkout', item], value: item };
});
